module.exports = __webpack_public_path__ + "img/dz.48d3012.webp";